
import { ref } from 'vue';
import { useWindowSize, useRect } from '@vant/use';

export default {
  name: 'SuspendIcon',
  props: [ 'iconUrl' ],
  setup() {
    const { width, height } = useWindowSize();
    
    return {
      width,
      height,
    }
  },
  data() {
    return {
      positionStyle: 'right: 0px; bottom: 120px;',
      coordinate: {
        client: {},
        elePosition: {},
      },
    };
  },
  computed: {
  },
  
  mounted() {},

  methods: {
    clickIcon() {
      this.$router.push({ name: 'livechat' });
    },
    touchstartHandle(refName, e, flag) { // 传false不拖拽
      if (!flag) {
        return false;
      };
      let element = e.targetTouches[0];
      
      // 记录点击的坐标
      this.coordinate.client = {
        x: element.clientX,
        y: element.clientY
      };
      // 记录需要移动的元素坐标
      this.coordinate.elePosition.left = this.$refs[refName].offsetLeft;
      this.coordinate.elePosition.top = this.$refs[refName].offsetTop;
    },
    touchmoveHandle(refName, e, flag) {
      if (!flag) {
        return false;
      };
      let element = e.targetTouches[0];
      // 根据初始 client 位置计算移动距离(元素移动位置=元素初始位置+光标移动后的位置-光标点击时的初始位置)
      let x = this.coordinate.elePosition.left + (element.clientX - this.coordinate.client.x);
      let y = this.coordinate.elePosition.top + (element.clientY - this.coordinate.client.y);
      // 限制可移动距离，不超出可视区域
      let leftLimit = 0;
      let rightLimit = innerWidth - this.$refs[refName].offsetWidth;
      let bottomLimit = innerHeight - this.$refs[refName].offsetHeight;
      x = x <= leftLimit ? leftLimit : x >= rightLimit ? rightLimit : x;
      y = y <= 0 ? 0 : y >= bottomLimit ? bottomLimit : y;
      // 移动当前元素
      this.$refs[refName].style.left = x + 'px';
      this.$refs[refName].style.top = y + 'px';
    },
    touchendHandle(refName, e, flag) {
      if (!flag) {
        return false;
      };
      let ringRect = useRect(this.$refs[refName]);
      // console.log(ringRect);
      let distanceX = ringRect.x + ringRect.width / 2, distanceY = ringRect.y + ringRect.height / 2;
      let position = 'right';
      // let positionX = 'left', positionY = 'top', position;
      // if(distanceX > this.width / 2) {
      //   distanceX = this.width - distanceX;
      //   positionX = 'right';
      // }
      // if(distanceY > this.height / 2) {
      //   distanceY = this.height - distanceY;
      //   positionY = 'bottom'
      // }
      // if (distanceY < distanceX) {
      //   position = positionY;
      // } else {
      //   position = positionX;
      // }
      // console.log('distanceX:', distanceX);
      // console.log('distanceY:', distanceY);
      // console.log(position);
      let x = ringRect.x;
      let y = ringRect.y;
      switch (position){
        case 'top':
          this.positionStyle = `top: ${0}px; left: ${x}px;`;
          break;
        case 'bottom':
          this.positionStyle = `bottom: ${0}px; left: ${x}px;`;
          break;
        case 'right':
          this.positionStyle = `right: ${0}px; top: ${y}px;`;
          break;
        default:
          this.positionStyle = `left: ${0}px; top: ${y}px;`;
          break;
      }
      this.position = position;
      // 判断拖动距离 小于5像素 触发click事件
      if (Math.abs(x - this.coordinate.elePosition.left) < 5 
        && Math.abs(y - this.coordinate.elePosition.top) < 5) {
        this.clickIcon();
      }
    },
  },
};
